import { Button, UncontrolledTooltip } from 'reactstrap'
import IconSet from '../../CMSComponent/icon'

/** Reload control for custom tables that are not driven by CMS grid settings */
const CustomTableReloadButton = ({ onReload, disabled, id = 'custom-table-reload', tooltip = 'Reload table data' }) => (
  <>
    <Button
      id={id}
      className='btn-warning border-0 btn-icon btn-icon-only fsize-1 m-2 no-print'
      disabled={disabled}
      onClick={onReload}>
      <IconSet icon='fa-solid fa-sync' color='light' />
    </Button>
    <UncontrolledTooltip placement='bottom' target={id}>
      {tooltip}
    </UncontrolledTooltip>
  </>
)

export default CustomTableReloadButton
